module.exports = __webpack_public_path__ + "static/media/fuse-logo.af66ed77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Login/assets/fuse-logo.svg
// module id = 1375
// module chunks = 193